import React from "react";

export const FlowParts = ({flow}) => {

    
    return(
        <div className="select_flow">
            <img src={`${process.env.REACT_APP_HOME_URL}/images/${flow}.png`}/>
        </div>
    )
}